import { render, staticRenderFns } from "./OrganizacionesComunitarias.vue?vue&type=template&id=699a7796&scoped=true&"
import script from "./OrganizacionesComunitarias.vue?vue&type=script&lang=ts&"
export * from "./OrganizacionesComunitarias.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizacionesComunitarias.vue?vue&type=style&index=0&id=699a7796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699a7796",
  null
  
)

export default component.exports